let libBelofte = null;
let privacyBelofte = null;

function laadLib(jsUrl, cssUrl) {
  if (window.maplibregl) return Promise.resolve();
  if (libBelofte) return libBelofte;

  libBelofte = (async () => {
    if (cssUrl && !document.querySelector(`link[href="${cssUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      document.head.appendChild(link);
    }

    if (/\.mjs(\?|$)/.test(jsUrl)) {
      await alsModule(jsUrl);
      return;
    }

    await alsScript(jsUrl);

    /* Een UMD-bundel zet window.maplibregl zelf. Staat die er na het laden
       niet, dan was het toch een module. Dan alsnog via import(), zodat een
       bestand met de verkeerde extensie geen dood spoor is. */
    if (!window.maplibregl) await alsModule(jsUrl);
  })();

  libBelofte = libBelofte.catch((e) => {
    libBelofte = null;
    throw e;
  });

  return libBelofte;
}

function alsScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('maplibre-gl.js niet gevonden in Assets'));
    document.head.appendChild(script);
  });
}

async function alsModule(url) {
  const mod = await import(url);
  window.maplibregl = mod.default || mod;
}

/* --- Toestemming ---------------------------------------------------------

   De tegels, de stijl en de lettertekens komen van tiles.openfreemap.org, en
   die server ziet bij elk verzoek het IP-adres van de bezoeker. Staat
   toestemming vragen aan, dan wordt er vooraf dus niets geladen: geen tegels,
   en ook MapLibre zelf niet, want zonder kaart is dat een megabyte voor niets.

   Er zijn drie wegen naar de kaart:
   1. In de theme editor meteen. Daar kijkt de handelaar zelf, en die wil zien
      wat hij instelt.
   2. Heeft de bezoeker in deze sessie al op de knop geklikt, dan onthouden we
      dat. Anders staat op elke pagina opnieuw dezelfde vraag.
   3. De Customer Privacy API van Shopify. Heeft de bezoeker in de
      cookiebanner voorkeuren aanvaard, dan laadt de kaart vanzelf, ook als
      dat pas gebeurt terwijl de pagina al openstaat.
   Anders blijft het paneel met de knop staan.

   Waarom niet alleen preferencesProcessingAllowed()
   Die geeft ook true als de bezoeker nog niets gekozen heeft, zolang Shopify
   voor zijn regio geen toestemming vraagt. Staat de cookiebanner uit, of niet
   ingesteld voor Belgie, dan geldt dat ook voor een Belgische bezoeker, en dan
   zou de kaart laden zonder dat iemand iets gevraagd is. Dus vragen we ook een
   uitdrukkelijk ja in currentVisitorConsent(). Wie in een regio zonder banner
   zit, klikt één keer op de knop. Dat is de goede kant om op te falen. */

const SESSIE_SLEUTEL = 'elisabeth:kaart-toestemming';

function sessieToestemming() {
  try {
    return window.sessionStorage.getItem(SESSIE_SLEUTEL) === 'ja';
  } catch (e) {
    return false; // opslag geblokkeerd, bijvoorbeeld in een privévenster
  }
}

function onthoudToestemming() {
  try {
    window.sessionStorage.setItem(SESSIE_SLEUTEL, 'ja');
  } catch (e) {
    /* niet te bewaren: dan vraagt de volgende pagina het gewoon opnieuw */
  }
}

/* loadFeatures haalt de API bij Shopify zelf, niet bij een derde. Ontbreekt
   Shopify of loadFeatures, of mislukt het laden, dan null: dan blijft het
   paneel staan. */
function laadPrivacyApi() {
  if (privacyBelofte) return privacyBelofte;

  privacyBelofte = new Promise((resolve) => {
    const shopify = window.Shopify;
    if (shopify?.customerPrivacy) {
      resolve(shopify.customerPrivacy);
      return;
    }
    if (typeof shopify?.loadFeatures !== 'function') {
      resolve(null);
      return;
    }
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fout) => {
        resolve(fout ? null : window.Shopify?.customerPrivacy || null);
      });
    } catch (e) {
      resolve(null);
    }
  });

  return privacyBelofte;
}

function voorkeurenAanvaard(api) {
  try {
    if (!api?.preferencesProcessingAllowed?.()) return false;
    return api.currentVisitorConsent?.()?.preferences === 'yes';
  } catch (e) {
    return false;
  }
}

/* [naam] en [aantal] in een vertaalde tekst invullen. Met een functie en niet
   met een vervangstring, zodat een $ in een naam niets bijzonders doet. */
function vul(sjabloon, waarden) {
  return sjabloon.replace(/\[(\w+)\]/g, (geheel, sleutel) =>
    sleutel in waarden ? String(waarden[sleutel]) : geheel
  );
}

/* De Nederlandse teksten, voor als het tekstblok in de sectie ontbreekt of
   stuk is. Dezelfde als in locales/nl.json. */
const STANDAARD_TEKSTEN = {
  pin: '[naam] op de kaart tonen',
  groep: '[aantal] boetieks in deze stad tonen',
  boetiek: 'Boetiek [nummer]',
  kaart: 'Kaart met de boetieks',
  inzoomen: 'Inzoomen',
  uitzoomen: 'Uitzoomen',
  zoomenCtrl: 'Gebruik Ctrl + scrollen om in te zoomen op de kaart',
  zoomenCmd: 'Gebruik ⌘ + scrollen om in te zoomen op de kaart',
  tweeVingers: 'Gebruik twee vingers om de kaart te verplaatsen',
  bronvermelding: 'Bronvermelding tonen of verbergen',
};

/* --- Afwijkende coördinaten ---------------------------------------------

   Eén verkeerd cijfer in een coördinaat is snel gemaakt: een lengtegraad van
   2.88 in plaats van 4.35 zet een boetiek in Brussel ruim honderd kilometer
   te ver naar het westen. Het gevolg is niet alleen een pin op de verkeerde
   plek. Klik je op de bubbel van die stad, dan past de kaart zich aan op alle
   boetieks van de groep, dus ook op die ene. Het beeld schuift naar het
   midden van die groep en de zes boetieks die er wel goed staan zijn niet
   meer te zien.

   Heeft een stad minstens drie boetieks en ligt er één ver van de rest, dan
   laten we die buiten de kaart. Het kaartje in de lijst blijft staan, alleen
   de pin en de bubbel houden er geen rekening meer mee. Er komt een melding
   in de console, zodat de handelaar weet welk coördinaat hij moet nakijken.

   Bij twee boetieks in één stad weten we niet welke van de twee fout is, dus
   daar doen we niets. */
const AFWIJKING_KM = 40;

/* Hoe ver openGroep maximaal mag uitzoomen om een hele stad in beeld te krijgen */
const ZOOM_VLOER = 9;

function afstandKm(a, b) {
  const rad = Math.PI / 180;
  const dLat = (b.lat - a.lat) * rad;
  const dLng = (b.lng - a.lng) * rad * Math.cos(((a.lat + b.lat) / 2) * rad);
  return Math.hypot(dLat, dLng) * 6371;
}

function mediaan(getallen) {
  const gesorteerd = [...getallen].sort((x, y) => x - y);
  const m = Math.floor(gesorteerd.length / 2);
  return gesorteerd.length % 2 ? gesorteerd[m] : (gesorteerd[m - 1] + gesorteerd[m]) / 2;
}

function zonderAfwijkers(items) {
  const perStad = new Map();
  items.forEach((item) => {
    if (!perStad.has(item.stad)) perStad.set(item.stad, []);
    perStad.get(item.stad).push(item);
  });

  const fout = new Set();
  perStad.forEach((groep) => {
    if (groep.length < 3) return;
    const midden = { lat: mediaan(groep.map((i) => i.lat)), lng: mediaan(groep.map((i) => i.lng)) };
    groep.forEach((item) => {
      const km = afstandKm(midden, item);
      if (km > AFWIJKING_KM) {
        fout.add(item);
        console.warn(
          `Locator: de coördinaten van "${item.naam}" (${item.lat}, ${item.lng}) liggen ${Math.round(km)} km van de andere boetieks in ${item.stad}. Controleer de velden lat en lng. Deze boetiek staat niet op de kaart.`
        );
      }
    });
  });

  return items.filter((item) => !fout.has(item));
}

/* Een custom element en geen losse klasse met een register.

   De reden is opruimen. De theme editor hertekent een blok bij elke
   wijziging aan een instelling. Bij een gewone klasse hoorde ik dat alleen
   via shopify:section:unload, en dat event komt bij theme blocks niet
   betrouwbaar aan. Gevolg: de oude kaart bleef bestaan, met zijn markers,
   in een container die al vervangen was. Meerdere kaarten door elkaar, en
   pins die rondspringen.

   Een custom element krijgt disconnectedCallback van de browser zodra het
   uit de DOM verdwijnt. Daar valt niets aan te missen. */
class BoetieksLocator extends HTMLElement {
  connectedCallback() {
    if (this.opgezet) return;
    this.opgezet = true;

    // Eén signaal voor alle luisteraars, zodat opruimen ze in één keer weghaalt
    this.luisteraars = new AbortController();
    const { signal } = this.luisteraars;

    this.vlak = this.querySelector('[data-bl-vlak]');
    this.lijst = this.querySelector('[data-bl-lijst]');
    this.paneel = this.querySelector('[data-bl-toestemming-paneel]');
    this.teksten = this.leesTeksten();

    this.traag = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.items = this.leesItems();
    this.markers = new Map(); // id -> {marker, element}
    this.groepen = new Map(); // stad -> [item]
    this.groepMarkers = new Map(); // stad -> {marker, element}

    this.zoomGekozen = parseFloat(this.dataset.blZoomGekozen) || 15;
    this.zoomGroep = parseFloat(this.dataset.blZoomGroep) || 12;
    this.fitMax = parseFloat(this.dataset.blFitMax) || 11;
    this.vluchtduur = parseFloat(this.dataset.blVlucht);
    if (Number.isNaN(this.vluchtduur)) this.vluchtduur = 1200;

    // De kaartjes werken ook zonder kaart: klikken selecteert dan alleen
    this.koppelKaartjes(signal);

    if (!this.vlak) return;

    /* Bewust geen check op items hier. Staat er nog geen enkele coordinaat
       ingevuld, dan laadt de kaart toch, gecentreerd op Belgie. Anders zie
       je een grijs vlak en lijkt de kaart stuk terwijl er alleen data
       ontbreekt. */
    if (!this.items.length) {
      console.info(
        'Locator: geen boetiek met lat en lng, dus geen pins. De kaart opent op Belgie.'
      );
    }

    if (this.hasAttribute('data-bl-toestemming')) {
      this.vraagToestemming(signal);
      return;
    }

    this.laadInZicht();
  }

  disconnectedCallback() {
    this.opruimen();
  }

  /* Pas laden als het blok in zicht komt. De bibliotheek is een paar
     honderd kilobyte en de tegels zijn losse verzoeken. */
  laadInZicht() {
    this.waarnemer?.disconnect();
    this.waarnemer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.waarnemer.disconnect();
          this.start();
        }
      },
      { rootMargin: '400px' }
    );
    this.waarnemer.observe(this);
  }

  /* --- Toestemming -------------------------------------------------------- */

  /* Zie de uitleg bovenaan dit bestand. Tot er toestemming is, gebeurt hier
     niets wat een verzoek naar buiten stuurt. */
  vraagToestemming(signal) {
    this.querySelector('[data-bl-laad]')?.addEventListener(
      'click',
      () => {
        onthoudToestemming();
        this.toestemmingGekregen(true);
      },
      { signal }
    );

    if (this.hasAttribute('data-bl-editor') || sessieToestemming()) {
      this.toestemmingGekregen(false);
      return;
    }

    /* Kiest de bezoeker pas later in de banner, dan meldt Shopify dat met dit
       event. Het vuurt alleen bij een wijziging, niet bij het registreren. */
    document.addEventListener(
      'visitorConsentCollected',
      (event) => {
        if (event.detail?.preferencesAllowed === true) this.toestemmingGekregen(false);
      },
      { signal }
    );

    laadPrivacyApi().then((api) => {
      if (this.isConnected && voorkeurenAanvaard(api)) this.toestemmingGekregen(false);
    });
  }

  /* Na een klik meteen laden: de knop staat óp de kaart, dus die is in beeld.
     Komt de toestemming uit de banner of van eerder in de sessie, dan pas als
     de kaart in zicht komt, net als zonder toestemmingsvraag. */
  toestemmingGekregen(geklikt) {
    if (this.toestemming) return;
    this.toestemming = true;

    /* Stond de focus op de knop, dan verdwijnt die met het paneel en valt de
       focus terug naar het begin van de pagina. Dus naar het kaartvlak: één
       keer tab en je zit in de kaart. */
    const hadFocus = this.paneel?.contains(document.activeElement);
    this.paneel?.remove();
    this.paneel = null;
    if (hadFocus && this.vlak) {
      this.vlak.setAttribute('tabindex', '-1');
      this.vlak.focus({ preventScroll: true });
    }

    if (geklikt) this.start();
    else this.laadInZicht();
  }

  /* --- Data --------------------------------------------------------------- */

  /* De vertaalde teksten uit de sectie. Wat ontbreekt of niet klopt, valt
     terug op het Nederlands. Shopify zet voor een ontbrekende vertaling een
     melding in de plaats, en die willen we niet als aria-label. */
  leesTeksten() {
    let vertaald = {};
    try {
      vertaald = JSON.parse(this.querySelector('[data-bl-teksten]')?.textContent || '{}') || {};
    } catch (e) {
      /* stuk blok: dan de standaardteksten */
    }

    const teksten = {};
    Object.entries(STANDAARD_TEKSTEN).forEach(([sleutel, standaard]) => {
      const waarde = vertaald[sleutel];
      const bruikbaar =
        typeof waarde === 'string' && waarde.trim() && !/translation missing/i.test(waarde);
      teksten[sleutel] = bruikbaar ? waarde : standaard;
    });
    return teksten;
  }

  leesItems() {
    const items = Array.from(this.querySelectorAll('[data-bl-item]'))
      .map((element, index) => ({
        id: element.dataset.blId || `boetiek-${index + 1}`,
        stad: element.dataset.blStad || `los-${index}`,
        naam:
          element.querySelector('[data-bl-item-naam]')?.textContent.trim() ||
          vul(this.teksten.boetiek, { nummer: index + 1 }),
        lat: Number.parseFloat(element.dataset.blLat),
        lng: Number.parseFloat(element.dataset.blLng),
        element,
      }))
      .filter((item) => Number.isFinite(item.lat) && Number.isFinite(item.lng));

    return zonderAfwijkers(items);
  }

  /* --- Kaart -------------------------------------------------------------- */

  async start() {
    try {
      await laadLib(this.dataset.blLib, this.dataset.blLibcss);

      /* Het laden duurt even. Heeft de theme editor de sectie intussen
         vervangen, dan is dit element al opgeruimd en zou de kaart in een
         losgekoppeld element blijven hangen, met zijn WebGL-context en
         luisteraars. Na een herkoppeling kan er ook al een kaart staan. */
      if (!this.isConnected || this.kaart) return;

      // Midden van Belgie als terugval. Lengtegraad eerst, dat is de
      // volgorde die MapLibre en Mapbox aanhouden.
      const start = this.items.length
        ? [this.items[0].lng, this.items[0].lat]
        : [4.47, 50.62];

      this.kaart = new maplibregl.Map({
        container: this.vlak,
        style: this.dataset.blStijl,
        center: start,
        zoom: 7,
        // Plat houden: kantelen en draaien voegt hier niets toe en zet de
        // pins schuin.
        dragRotate: false,
        pitchWithRotate: false,
        touchPitch: false,
        // Scrollen over de kaart scrollt de pagina, tenzij je ctrl of cmd
        // indrukt. Zonder dit blijft de bezoeker in de kaart hangen.
        cooperativeGestures: true,
        attributionControl: { compact: true },
        /* MapLibre spreekt standaard Engels. Alleen de teksten die deze kaart
           echt toont; kompas, volledig scherm en geolocatie staan hier uit. */
        locale: {
          'Map.Title': this.teksten.kaart,
          'NavigationControl.ZoomIn': this.teksten.inzoomen,
          'NavigationControl.ZoomOut': this.teksten.uitzoomen,
          'CooperativeGesturesHandler.WindowsHelpText': this.teksten.zoomenCtrl,
          'CooperativeGesturesHandler.MacHelpText': this.teksten.zoomenCmd,
          'CooperativeGesturesHandler.MobileHelpText': this.teksten.tweeVingers,
          'AttributionControl.ToggleAttribution': this.teksten.bronvermelding,
        },
      });

      this.kaart.touchZoomRotate?.disableRotation();
      this.kaart.addControl(
        new maplibregl.NavigationControl({ showCompass: false }),
        'top-left'
      );

      /* ---------------------------------------------------------------------
         Waarom de pins niet meer op het load-event wachten
         ---------------------------------------------------------------------
         Eerst hing alles aan kaart.on('load'). Dat event vuurt pas als de
         stijl volledig geladen is, inclusief bronnen, glyphs en sprite. Blijft
         daar iets hangen, dan komt load nooit, en dan werden de markers dus
         nooit aangemaakt. Precies dat gebeurde hier: isStyleLoaded() bleef
         false terwijl alle netwerkverzoeken wel 200 gaven.

         Markers hebben die stijl niet nodig. Het zijn HTML-elementen die
         MapLibre op een coordinaat zet; daarvoor is alleen de camera nodig.
         Dus bouwen we ze meteen.

         Alleen het inkleuren heeft de stijl echt nodig. Dat hangt nu aan
         styledata, dat vuurt zodra de stijl-JSON geparsed is, veel eerder dan
         load. Blijft de stijl alsnog hangen, dan verlies je de huisstijl-
         kleuren maar niet de pins. Dat is de goede kant om op te falen. */

      this.bouwMarkers();

      /* Eerst bepalen wat zichtbaar hoort te zijn, dan het beeld passen.
         Andersom zou je één frame alle losse pins én de groepsbubbels
         tegelijk zien, en bij zes winkels in Brussel is dat een prop. */
      this.herbekijkGroepen();
      this.kaart.on('zoom', () => this.herbekijkGroepen());
      this.pasBeeldAan();

      this.kaart.on('styledata', () => this.kleurEenmalig());

      this.kaart.on('error', (e) => {
        console.warn('Locator: fout in de kaart.', e?.error || e);
      });

      this.bewaakFormaat();
    } catch (e) {
      console.warn('Locator: kaart niet geladen, de lijst blijft werken.', e);
      this.paneel?.remove();
    }
  }

  /* Huisstijlkleuren over de aangeleverde stijl leggen.

     Op basis van laagtype en een naamtest, niet op vaste laag-id's: die
     verschillen per stijl en veranderen zonder waarschuwing. Zo blijft dit
     werken als je van positron naar bright wisselt. */
  /* styledata kan meerdere keren vuren. Eén keer kleuren is genoeg, en de
     lagen aflopen bij elke wijziging kost onnodig werk. */
  kleurEenmalig() {
    if (this.gekleurd) return;
    if (!this.kaart.getStyle() || !this.kaart.getStyle().layers) return;
    this.gekleurd = true;
    this.kleurStijl();
  }

  kleurStijl() {
    const land = this.dataset.blLand;
    if (!land) return; // huisstijlkleuren staan uit

    const water = this.dataset.blWater;
    const weg = this.dataset.blWeg;
    const label = this.dataset.blLabel;

    const zet = (id, eigenschap, waarde) => {
      try {
        this.kaart.setPaintProperty(id, eigenschap, waarde);
      } catch (e) {
        /* deze laag accepteert deze eigenschap niet, verder gaan */
      }
    };

    const isWater = (id) => /water|ocean|sea|river|lake|bay/i.test(id);
    const isGrens = (id) => /boundary|admin|border/i.test(id);

    this.kaart.getStyle().layers.forEach((laag) => {
      const id = laag.id;

      switch (laag.type) {
        case 'background':
          zet(id, 'background-color', land);
          break;
        case 'fill':
          zet(id, 'fill-color', isWater(id) ? water : land);
          zet(id, 'fill-outline-color', isWater(id) ? water : land);
          break;
        case 'fill-extrusion':
          zet(id, 'fill-extrusion-color', land);
          break;
        case 'line':
          if (isWater(id)) {
            zet(id, 'line-color', water);
          } else if (isGrens(id)) {
            zet(id, 'line-color', label);
            zet(id, 'line-opacity', 0.25);
          } else {
            zet(id, 'line-color', weg);
          }
          break;
        case 'symbol':
          zet(id, 'text-color', label);
          zet(id, 'text-halo-color', '#ffffff');
          zet(id, 'text-halo-width', 1.5);
          break;
        default:
          break;
      }
    });
  }

  /* --- Markers ------------------------------------------------------------ */

  bouwMarkers() {
    this.items.forEach((item) => {
      if (!this.groepen.has(item.stad)) this.groepen.set(item.stad, []);
      this.groepen.get(item.stad).push(item);
    });

    // Losse pin per boetiek
    this.items.forEach((item) => {
      const element = this.kloon('[data-bl-pin-template]', 'bl-pin');
      element.setAttribute('data-bl-marker', item.id);
      element.setAttribute('aria-label', vul(this.teksten.pin, { naam: item.naam }));
      this.maakBedienbaar(element, () => this.kies(item.id));

      /* Meteen op de kaart, en daar blijven ze ook. Verbergen doen we met
         CSS, niet door de marker van de kaart te halen. Zie de noot bij
         herbekijkGroepen. */
      const marker = new maplibregl.Marker({ element, anchor: 'center' })
        .setLngLat([item.lng, item.lat])
        .addTo(this.kaart);
      this.markers.set(item.id, { marker, element });
    });

    // Bubbel per stad met meer dan één boetiek
    this.groepen.forEach((groep, stad) => {
      if (groep.length < 2) return;

      const element = this.kloon('[data-bl-groep-template]', 'bl-groep');
      const teller = element.querySelector('[data-bl-groep-aantal]') || element;
      teller.textContent = String(groep.length);
      element.setAttribute('data-bl-marker', `stad:${stad}`);
      // Een bubbel heeft altijd minstens twee boetieks, dus altijd meervoud
      element.setAttribute('aria-label', vul(this.teksten.groep, { aantal: groep.length }));
      this.maakBedienbaar(element, () => this.openGroep(stad));

      const marker = new maplibregl.Marker({ element, anchor: 'center' })
        .setLngLat([
          groep.reduce((t, i) => t + i.lng, 0) / groep.length,
          groep.reduce((t, i) => t + i.lat, 0) / groep.length,
        ])
        .addTo(this.kaart);
      this.groepMarkers.set(stad, { marker, element });
    });
  }

  /* De blauwdruk staat in de DOM en niet in een JS-string, zodat de opmaak
     in Liquid blijft. Staat hij er niet, dan een kale stip. */
  kloon(selector, klasse) {
    const template = this.querySelector(selector);
    if (!template) {
      const stip = document.createElement('button');
      stip.type = 'button';
      stip.className = klasse;
      return stip;
    }
    const element = template.cloneNode(true);
    element.removeAttribute('data-bl-pin-template');
    element.removeAttribute('data-bl-groep-template');
    element.setAttribute('data-active', 'false');
    return element;
  }

  /* De blauwdrukken zijn divs, geen buttons. Dus zelf de rol, de tabstop en
     de toetsen erbij, anders is de kaart alleen met een muis te gebruiken. */
  maakBedienbaar(element, doen) {
    if (!element.matches('button, a, input')) {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
    }
    element.setAttribute('aria-pressed', 'false');
    element.addEventListener('click', doen);
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      doen();
    });
  }

  /* Verbergen met een attribuut, niet door de marker van de kaart te halen.

     Eerst deed ik dat wel met addTo en remove, en dat was de oorzaak van de
     springende pins. Het zoom-event vuurt tientallen keren per seconde
     tijdens een vlucht. Kruis je dan de grens waarop een groep uiteenvalt,
     dan worden er midden in de animatie markers uit de DOM gehaald en nieuwe
     ingehangen. Zo'n nieuwe marker staat één frame op de plek waar MapLibre
     hem nog niet berekend heeft, en dat zie je als een sprong.

     Nu staan alle markers permanent op de kaart. MapLibre houdt hun positie
     bij, wij zetten alleen een attribuut. Geen DOM-wissels, geen sprong. */
  toon(paar, aan) {
    if (!paar || paar.zichtbaar === aan) return;
    paar.element.toggleAttribute('data-bl-verborgen', !aan);
    paar.zichtbaar = aan;
  }

  /* Bubbel of losse pins, afhankelijk van hoe diep je ingezoomd bent.

     Een groep die de bezoeker net opende (tik op de bubbel) toont zijn pins
     ook onder het ingestelde zoomniveau, zolang de kaart nog ongeveer zo ver
     is ingezoomd als bij het openen. Op een smalle kaart, zoals op een
     telefoon, past de hele stad namelijk niet meer in beeld op het zoomniveau
     waarop de groepen normaal uiteenvallen. Dwing je dan toch dat niveau af,
     dan staat de helft van de boetieks buiten het scherm. */
  herbekijkGroepen() {
    if (!this.kaart) return;
    const zoom = this.kaart.getZoom();

    this.groepen.forEach((groep, stad) => {
      if (groep.length < 2) {
        this.toon(this.markers.get(groep[0].id), true);
        return;
      }
      const geopend = this.geopend === stad && zoom >= this.geopendZoom - 0.75;
      const uit = zoom >= this.zoomGroep || geopend;
      this.toon(this.groepMarkers.get(stad), !uit);
      groep.forEach((item) => this.toon(this.markers.get(item.id), uit));
    });
  }

  pasBeeldAan() {
    if (!this.items.length) return; // niets om op te passen, terugval staat al goed

    if (this.items.length === 1) {
      this.kaart.jumpTo({
        center: [this.items[0].lng, this.items[0].lat],
        zoom: this.zoomGekozen,
      });
      return;
    }

    const grenzen = new maplibregl.LngLatBounds();
    this.items.forEach((item) => grenzen.extend([item.lng, item.lat]));
    this.kaart.fitBounds(grenzen, {
      padding: this.opvulling(64),
      maxZoom: this.fitMax,
      animate: false,
    });
  }

  /* Bij de indeling over de kaart ligt het paneel links óp de kaart. Met
     dezelfde opvulling rondom vallen de westelijkste pins eronder. Dus links
     de rechterrand van het paneel erbij. Staat het paneel niet absoluut
     (indeling naast, of onder 990px), dan blijft het rondom gelijk. */
  opvulling(basis) {
    const zij = this.querySelector('.bl__zij');
    if (!zij || getComputedStyle(zij).position !== 'absolute') return basis;

    const paneelRand = zij.getBoundingClientRect().right - this.vlak.getBoundingClientRect().left;
    return { top: basis, right: basis, bottom: basis, left: Math.max(basis, paneelRand + basis) };
  }

  /* --- Selecteren --------------------------------------------------------- */

  koppelKaartjes(signal) {
    this.items.forEach((item) => {
      item.element.addEventListener(
        'click',
        (event) => {
          // Links en knoppen in het kaartje blijven gewoon werken
          if (event.target.closest('a, button, input, select, textarea')) return;
          this.kies(item.id);
        },
        { signal }
      );

      item.element.addEventListener(
        'keydown',
        (event) => {
          if (event.target !== item.element) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.kies(item.id);
        },
        { signal }
      );
    });
  }

  kies(id) {
    const item = this.items.find((i) => i.id === id);
    if (!item) return;

    this.zetActief(id);

    if (this.kaart) {
      const camera = { center: [item.lng, item.lat], zoom: this.zoomGekozen };
      if (this.traag.matches) this.kaart.jumpTo(camera);
      else this.kaart.flyTo({ ...camera, duration: this.vluchtduur, essential: false });
    }

    this.brengInBeeld(item.element);
  }

  openGroep(stad) {
    const groep = this.groepen.get(stad) || [];
    if (!groep.length) return;

    const grenzen = new maplibregl.LngLatBounds();
    groep.forEach((item) => grenzen.extend([item.lng, item.lat]));

    /* Niet fitBounds: die heeft geen minimum, en bij twee boetieks op
       honderd meter van elkaar zou hij tot straatniveau inzoomen. Zelf de
       camera berekenen en de zoom begrenzen.

       Naar boven toe op zoomGroep + 3. Naar onder toe niet meer op zoomGroep:
       dan viel een stad op een smalle kaart deels buiten beeld (zie
       herbekijkGroepen). Alle boetieks van de stad moeten in beeld passen,
       met een vloer zodat een foute coordinaat de kaart niet tot over het
       land uitzoomt.

       De opvulling volgt de breedte van de kaart: 90px aan elke kant is op
       een kaart van 390px meer dan de helft van de breedte. */
    const vlak = this.vlak.getBoundingClientRect();
    const opvulling = this.opvulling(Math.round(Math.min(90, Math.max(32, vlak.width * 0.12))));
    const cam = this.kaart.cameraForBounds(grenzen, { padding: opvulling });
    const zoom = Math.min(Math.max(cam?.zoom ?? this.zoomGroep, ZOOM_VLOER), this.zoomGroep + 3);

    this.geopend = stad;
    this.geopendZoom = zoom;

    this.kaart.easeTo({
      center: cam?.center ?? grenzen.getCenter(),
      zoom,
      duration: this.traag.matches ? 0 : 600,
    });

    this.herbekijkGroepen();
    this.zetActief(null);
    groep.forEach((item) => item.element.setAttribute('data-active', 'true'));
    this.brengInBeeld(groep[0].element);
  }

  /* Alleen de lijst zelf verschuiven, nooit het document.

     Eerst stond hier scrollIntoView met inline: nearest. Dat scrollt de
     dichtstbijzijnde scrollbare voorouder, en als de pagina zelf een paar
     pixels horizontale overloop heeft, is dat het document. Op mobiel
     schoof daardoor de hele pagina zijwaarts zodra je een boetiek koos, en
     zag je de header half buiten beeld staan.

     De marge eraf trekken is geen detail. getBoundingClientRect geeft de
     buitenrand van de baan, en die ligt op mobiel op de vensterrand omdat
     de baan van rand tot rand loopt. Reken je daarmee, dan zet je het
     kaartje tegen de vensterrand in plaats van onder de titel: precies de
     padding-inline die er in de CSS bewust op zit, weer weggeschoven. Met
     mandatory snap zie je dat als een sprong die zichzelf corrigeert. */
  brengInBeeld(el) {
    const baan = this.lijst;
    if (!baan) return;

    const gedrag = this.traag.matches ? 'auto' : 'smooth';
    const baanVak = baan.getBoundingClientRect();
    const elVak = el.getBoundingClientRect();

    if (baan.scrollWidth > baan.clientWidth + 2) {
      const marge = parseFloat(getComputedStyle(baan).paddingLeft) || 0;
      baan.scrollTo({ left: baan.scrollLeft + (elVak.left - baanVak.left) - marge, behavior: gedrag });
    } else if (baan.scrollHeight > baan.clientHeight + 2) {
      const marge = parseFloat(getComputedStyle(baan).paddingTop) || 0;
      baan.scrollTo({ top: baan.scrollTop + (elVak.top - baanVak.top) - marge, behavior: gedrag });
    }
  }

  zetActief(id) {
    this.items.forEach((item) => {
      const actief = item.id === id;
      item.element.setAttribute('data-active', String(actief));

      const paar = this.markers.get(item.id);
      if (paar) {
        paar.element.setAttribute('data-active', String(actief));
        paar.element.setAttribute('aria-pressed', String(actief));
      }
    });

    this.groepMarkers.forEach((paar) => {
      paar.element.setAttribute('data-active', 'false');
      paar.element.setAttribute('aria-pressed', 'false');
    });
  }

  /* MapLibre meet zijn canvas bij het aanmaken. Verandert de container
     daarna van formaat, dan blijft het canvas op de oude maat staan: dan
     zie je een uitgerekte kaart, of niets.

     Alleen naar window resize kijken is niet genoeg. Bij deze indeling
     verandert de container ook zonder dat het venster verandert: van een
     kolom naast de lijst naar volle breedte eronder, of doordat de theme
     editor de sectie hertekent. Een ResizeObserver op de kaartcontainer
     ziet dat allemaal; window resize ziet er maar één van. */
  bewaakFormaat() {
    let timer;
    const opnieuwMeten = () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.kaart?.resize(), 100);
    };

    if ('ResizeObserver' in window) {
      this.formaatWaarnemer = new ResizeObserver(opnieuwMeten);
      this.formaatWaarnemer.observe(this.vlak);
    }

    this.formaatHandler = opnieuwMeten;
    window.addEventListener('resize', this.formaatHandler, { passive: true });
  }

  opruimen() {
    // Kaartjes, de knop en de luisteraar op de cookiebanner
    this.luisteraars?.abort();
    this.waarnemer?.disconnect();
    this.formaatWaarnemer?.disconnect();
    if (this.formaatHandler) {
      window.removeEventListener('resize', this.formaatHandler);
    }
    this.kaart?.remove();
    this.kaart = null;
    this.geopend = null;
    // Een volgende kaart moet opnieuw ingekleurd worden
    this.gekleurd = false;
    // Na herkoppelen opnieuw nagaan, want de keuze kan intussen veranderd zijn
    this.toestemming = false;
    this.opgezet = false;
  }
}

/* Geen eigen register en geen luisteraars op shopify:section:load meer. De
   browser roept connectedCallback op zodra het element in de pagina komt en
   disconnectedCallback zodra het eruit gaat, en dat geldt ook voor wat de
   theme editor hertekent. */
if (!customElements.get('boetieks-locator')) {
  customElements.define('boetieks-locator', BoetieksLocator);
}